'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _helpers = require('./_helpers');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YotpoOverride = {
  init: function init(_ref) {
    var el = _ref.el,
        context = _ref.context;

    this.context = context;
    this.els = {
      el: el,
      reviewCount: context.getElement('.' + context.className + '_Count'),
      reviewCarousel: context.getElement('.' + context.className + '_Carousel'),
      reviewCarouselItems: context.getElement('.' + context.className + '_Items')
    };

    this.data = {
      app_key: 'H0N4gFt1VagTkGLGCnHrF5Zjesw9fIN1aVzczPbV',
      u_token: 'NMD1sCjKWsqQoT0UNe6eZmrZd0AqaQ4LsTQPFbmn',
      product_id: typeof this.els.el.dataset.productId !== 'undefined' ? this.els.el.dataset.productId : null
    };

    if (this.data.app_key === null) {
      return;
    }

    this.carousel = undefined;
    this.currentSizing = undefined;

    this.listeners = (0, _create2.default)(_helpers.Listeners);

    this.methods.getReviews = this.methods.getReviews.bind(this);
    this.methods.populateReviewCount = this.methods.populateReviewCount.bind(this);
    this.methods.buildCarousel = this.methods.buildCarousel.bind(this);
    this.methods.initCarousel = this.methods.initCarousel.bind(this);

    this.setupListeners();
  },

  setupListeners: function setupListeners() {
    var _this2 = this;

    window.addEventListener('load', function (e) {
      _this2.methods.getReviews();
    });

    window.addEventListener('resize', function (e) {
      _this2.methods.initCarousel();
    });
  },


  methods: {
    getReviews: function getReviews() {
      var _this = this;

      var data = null;

      var xhr = new XMLHttpRequest();

      var endpoints = {
        all_reviews: 'https://api.yotpo.com/v1/apps/' + _this.data.app_key + '/reviews?utoken=' + _this.data.u_token + '&page=1&count=12',
        site_reviews: 'https://api.yotpo.com/v1/widget/' + _this.data.app_key + '/products/yotpo_site_reviews/reviews.json?per_page=6&page=1',
        product_reviews: 'https://api.yotpo.com/v1/widget/' + _this.data.app_key + '/products/' + _this.data.product_id + '/reviews.json',
        top_three_5_star: 'https://api.yotpo.com/apps/' + _this.data.app_key + '/top_reviews.json'
      };

      var endpoint = endpoints.top_three_5_star;

      if (this.data.product_id != null) {
        endpoint = endpoints.product_reviews;
      }

      xhr.addEventListener('readystatechange', function () {
        if (this.readyState === this.DONE) {
          var response = JSON.parse(this.responseText);
          var reviews = {};

          var statusCode = typeof response.status !== 'undefined' ? response.status.code : 200;

          if (statusCode === 200 && this.responseText.length) {
            if (typeof response.response !== 'undefined') {
              reviews = response.response;
            }

            if (typeof response.reviews !== 'undefined') {
              reviews = response.reviews;
            }

            var totalReviews = reviews.length;

            if (typeof reviews.bottomline !== 'undefined') {
              totalReviews = reviews.bottomline.total_review;
              reviews = reviews.reviews;
            }

            _this.methods.populateReviewCount(totalReviews);
            _this.methods.buildCarousel(reviews);
          }
        }
      });

      xhr.open('GET', endpoint);

      xhr.setRequestHeader('content-type', 'application/json');

      xhr.send(data);
    },
    populateReviewCount: function populateReviewCount(total) {
      this.els.reviewCount.innerHTML = total;
    },
    buildCarousel: function buildCarousel(reviews) {
      var _this3 = this;

      if (reviews.length) {
        reviews.forEach(function (review) {
          var reviewItemHtml = _this3.cardTemplate;
          var reviewItem = document.createElement('li');
          var reviewRating = review.score / 5;
          var reviewVerifiedHtml = '';

          if (review.verified_buyer === true) {
            reviewVerifiedHtml = '<span class="yp-ReviewItem_Verified">Verified Buyer</span>';
          }

          reviewItem.classList.add('yp-ReviewItem');
          reviewItem.classList.add('swiper-slide');
          reviewItem.classList.add(_this3.context.className + '_Slide');

          reviewItemHtml = reviewItemHtml.replace(/{{score}}/g, 97 * reviewRating);
          reviewItemHtml = reviewItemHtml.replace(/{{title}}/g, review.title);
          reviewItemHtml = reviewItemHtml.replace(/{{content}}/g, review.content);
          reviewItemHtml = reviewItemHtml.replace(/{{author}}/g, typeof review.user !== 'undefined' ? review.user.display_name : new Date(review.created_at).toLocaleDateString('en-GB'));
          reviewItemHtml = reviewItemHtml.replace(/{{verified_html}}/g, reviewVerifiedHtml);

          reviewItem.innerHTML = reviewItemHtml;

          _this3.els.reviewCarouselItems.appendChild(reviewItem);

          /*
          this.els.reviewCarouselItems.appendChild(reviewItem.cloneNode(true));
          this.els.reviewCarouselItems.appendChild(reviewItem.cloneNode(true));
          this.els.reviewCarouselItems.appendChild(reviewItem.cloneNode(true));
          this.els.reviewCarouselItems.appendChild(reviewItem.cloneNode(true));
          this.els.reviewCarouselItems.appendChild(reviewItem.cloneNode(true));
          */
        });

        this.methods.initCarousel();
      }
    },
    initCarousel: function initCarousel() {
      if (this.currentSizing !== 'desktop' && window.innerWidth >= _utils.mediaBreakpoints.sm && this.carousel !== undefined) {
        this.carousel.destroy();
        this.carousel = undefined;
      } else if (this.currentSizing !== 'mobile' && window.innerWidth < _utils.mediaBreakpoints.sm && this.carousel !== undefined) {
        this.carousel.destroy();
        this.carousel = undefined;
      }

      if (window.innerWidth > _utils.mediaBreakpoints.sm) {
        var _breakpoints;

        this.currentSizing = 'desktop';
        this.carousel = (0, _helpers.initialiseSwiper)(this.els.reviewCarousel, {
          loop: true,
          watchSlidesProgress: true,
          slidesPerView: 1.5,
          centeredSlides: true,
          initialSlide: 1,
          spaceBetween: 5,
          speed: 500,
          grabCursor: true,
          slideClass: this.context.className + '_Slide',
          breakpointsInverse: true,
          breakpoints: (_breakpoints = {}, (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.md, {
            slidesPerView: 2
          }), (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.lg, {
            slidesPerView: 3
          }), _breakpoints)
        });
      } else {
        this.currentSizing = 'mobile';
        this.carousel = (0, _helpers.initialiseSwiper)(this.els.reviewCarousel, {
          loop: false,
          watchSlidesProgress: true,
          slidesPerView: 1.2,
          centeredSlides: true,
          initialSlide: 2,
          spaceBetween: 5,
          speed: 500,
          slideClass: this.context.className + '_Slide'
        });
      }
    }
  },

  cardTemplate: '\n    <div class="yp-ReviewItem_Inner">\n      <div class="yp-ReviewItem_Header">\n        <div class="yp-ReviewItem_Stars">\n          <div class="yp-ReviewItem_StarsInner">\n            <div class="yp-ReviewItem_StarsFilled">\n              <svg class="yp-ReviewItem_StarsSvg yp-ReviewItem_StarsSvg-filled" viewBox="0 0 {{score}} 16" xmlns="http://www.w3.org/2000/svg">\n                <g fill-rule="evenodd">\n                  <path d="M93.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L80 6.083h6.396L88.372 0l1.976 6.083h6.396l-5.174 3.76 1.976 6.083zM73.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L60 6.083h6.396L68.372 0l1.976 6.083h6.396l-5.174 3.76 1.976 6.083zM33.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L20 6.083h6.396L28.372 0l1.976 6.083h6.396l-5.174 3.76zM13.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L0 6.083h6.396L8.372 0l1.976 6.083h6.396l-5.174 3.76zM53.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L40 6.083h6.396L48.372 0l1.976 6.083h6.396l-5.174 3.76z"/>\n                </g>\n              </svg>\n            </div>\n            <svg class="yp-ReviewItem_StarsSvg yp-ReviewItem_StarsSvg-empty" viewBox="0 0 97 16" xmlns="http://www.w3.org/2000/svg">\n                <g fill-rule="evenodd">\n                  <path d="M93.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L80 6.083h6.396L88.372 0l1.976 6.083h6.396l-5.174 3.76 1.976 6.083zM73.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L60 6.083h6.396L68.372 0l1.976 6.083h6.396l-5.174 3.76 1.976 6.083zM33.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L20 6.083h6.396L28.372 0l1.976 6.083h6.396l-5.174 3.76zM13.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L0 6.083h6.396L8.372 0l1.976 6.083h6.396l-5.174 3.76zM53.546 15.926l-5.174-3.76-5.174 3.76 1.976-6.084L40 6.083h6.396L48.372 0l1.976 6.083h6.396l-5.174 3.76z"/>\n                </g>\n            </svg>\n          </div>\n        </div>\n        <h3 class="yp-ReviewItem_Title">{{title}}</h3>\n      </div> \n      <div class="yp-ReviewItem_Body">\n        <p class="yp-ReviewItem_Content">{{content}}</p>\n      </div>  \n      <div class="yp-ReviewItem_Footer">\n        <p class="yp-ReviewItem_Author">{{author}} {{verified_html}}</p>        \n      </div>  \n    </div>\n  '
};

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var yotpoOverride = (0, _create2.default)(YotpoOverride);
  yotpoOverride.init({ el: el, context: context });
}